export function areAllTreeItemsSelected(treeItems, selectedItemIds) {
    if (!selectedItemIds) {
        return false;
    }
    for (const item of treeItems) {
        if (!selectedItemIds.includes(item.id)) {
            return false;
        }
        if (item.children) {
            const allSelected = areAllTreeItemsSelected(item.children, selectedItemIds);
            if (!allSelected) {
                return false;
            }
        }
    }
    return true;
}
